import { render, staticRenderFns } from "./GuideBoard.vue?vue&type=template&id=7cf44089&"
import script from "./GuideBoard.vue?vue&type=script&lang=js&"
export * from "./GuideBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports